import { render, staticRenderFns } from "./BuyApproach.vue?vue&type=template&id=11fc0032&scoped=true"
import script from "./BuyApproach.vue?vue&type=script&lang=js"
export * from "./BuyApproach.vue?vue&type=script&lang=js"
import style0 from "./BuyApproach.vue?vue&type=style&index=0&id=11fc0032&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc0032",
  null
  
)

export default component.exports